import { DefaultQueryParams, environmentBuilder, GameLiveConnection, parseQuery } from '@pascal/pascal-core';
import { gameService } from './GameService';
import { gameName, socketBetShopPath, socketGamePath } from '../enums/gameConfigsAndUrls';
import { BET_SHOP_GAME_ID, SOCKET_METHODS } from '../enums/constants';
import { gameConfigStore, popupStore } from '@pascal/pascal-core/shared/core/store';

let connectionCount = 0;

export class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
    const { gameTypeId } = gameConfigStore;
    if (isFirst) {
      this.executeConnections();
    }
    await super.sendGetInitialState({ partnerId, gameTypeId });
  }

  handleInitialResult(data) {
    const { gameTypeId } = gameConfigStore;
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);

    if (!data || !data.roundInfo) {
      if (connectionCount > 2) {
        // popupStore.open({ name: PopUps.ConnectionError });
        popupStore.onConnectionError(true);
      } else {
        setTimeout(() => {
          connectionCount += 1;
          super.sendGetInitialState({ partnerId, gameTypeId }).then(() => {});
        }, 1500);
      }
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  executeConnections() {
    // INITIAL
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));
    // INITIAL
    super.onMaintenanceNotify();
    super.onReconnecting(gameService.handleReconnecting.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onClose(gameService.handleConnectionError.bind(gameService));
    super.on(SOCKET_METHODS.GetBalanceResult, gameService.handleBalanceUpdate.bind(gameService));
    super.onBalanceUpdate();
    super.onGetBalanceResult();
    // super.on('error',gameService.handleConnectionError.bind(gameService));
    super.onRoundFinished(gameService.handleRoundFin.bind(gameService));
    super.onGameOpen();
    super.onFreeBetEnded();
    super.onFreeBetAwarded();
    super.onLobbyUsersCount();
    super.onFreeBetCountUpdate();
    super.onRoundStarted(gameService.handleRoundStart.bind(gameService));
    super.onBetsClosed(gameService.handleBetsClosed.bind(gameService));
    // super.onBalanceUpdate(gameService.handleBalanceUpdate.bind(gameService));
    super.onDoBetResult(gameService.handleDoBetResult.bind(gameService));
    super.onDoBetResultValidation(gameService.handleDoBetResultValidation.bind(gameService));
  }
}

const { socketUrl } = environmentBuilder(gameName);
const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const isBetShop = +gameId === BET_SHOP_GAME_ID;

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(isBetShop ? socketBetShopPath : socketGamePath));
